import Vue from "vue";
import sectionService from "../../services/section/section";
import { Section } from "../../services/section/entities/section.interface";
import { uploadTask, deleteTask } from "../../firebase";
import constants from "../../config/constants";
import { SectionState } from "./states/section.state.interface";

export default {
  namespaced: true,
  state: {
    sections: [],
    totalSections: 0
  },
  getters: {
    getSections: (state: SectionState) => state.sections,
    getTotalSections: (state: SectionState) => state.totalSections
  },
  mutations: {
    setSections(state: SectionState, sections: Array<Section>) {
      Vue.set(state, "sections", sections);
    },
    setTotalSections(state: SectionState, totalSections: number) {
      Vue.set(state, "totalSections", totalSections);
    }
  },
  actions: {
    getSections: async (context: any, payload: any) => {
      context.commit("setSections", []);
      await sectionService.getSections(payload).then((response: any) => {
        context.commit("setTotalSections", response.data.totalSections);
        context.commit("setSections", response.data.sections);
      });
    },
    getSectionsToClient: async (context: any) => {
      await sectionService.getSectionsToClient().then((response: any) => {
        context.commit("setSections", response.data.sections);
      });
    },
    createSection: async (context: any, payload: any) => {
      let created = false;
      await sectionService
        .createSection(payload)
        .then(async (response: any) => {
          created = response.data.created;
          if (!payload.hosted) {
            const mediaURL = await uploadTask(
              response.data.sectionID,
              constants.TABLE.SECTION,
              payload.mediaUrl
            );
            await sectionService.updateSection({
              sectionId: response.data.sectionID,
              mediaUrl: mediaURL,
              mediaType: payload.mediaType
            });
          } else {
            await sectionService.updateSection({
              sectionId: response.data.sectionID,
              mediaUrl: payload.mediaUrl,
              mediaType: payload.mediaType
            });
          }
          await sectionService.getSections(payload).then((response: any) => {
            context.commit("setTotalSections", response.data.totalSections);
            context.commit("setSections", response.data.sections);
          });
        });
      return created;
    },
    updateSection: async (context: any, payload: any) => {
      let updated = false;
      if (payload.newMediaFile !== undefined) {
        const newFileURL = await uploadTask(
          payload.sectionId,
          constants.TABLE.SECTION,
          payload.newMediaFile
        );
        payload.mediaUrl = newFileURL;
        payload.mediaType = payload.newMediaType;
        if (!payload.currentHosted) {
          await deleteTask(payload.currentMedia);
        }
      }

      if (payload.newHostedURL !== undefined) {
        payload.mediaUrl = payload.newHostedURL;
        payload.mediaType = "HOSTED";
        if (!payload.currentHosted) {
          await deleteTask(payload.currentMedia);
        }
      }

      await sectionService
        .updateSection(payload)
        .then(async (response: any) => {
          updated = response.data.updated;
          await sectionService.getSections(payload).then((response: any) => {
            context.commit("setTotalSections", response.data.totalSections);
            context.commit("setSections", response.data.sections);
          });
        });
      return updated;
    },
    deleteSection: async (context: any, payload: any) => {
      let deleted = false;
      await sectionService
        .deleteSection(payload.sectionId)
        .then(async (response: any) => {
          deleted = response.data.deleted;
          if (payload.sectionMediaType !== "HOSTED") {
            await deleteTask(payload.sectionMediaURL);
          }

          await sectionService
            .getSections(payload)
            .then(async (response: any) => {
              if (payload.page > 1 && response.data.sections.length == 0) {
                payload.start =
                  (payload.page - 1) * constants.ITEMS_PER_PAGE -
                  constants.ITEMS_PER_PAGE;
                await sectionService
                  .getSections(payload)
                  .then((response: any) => {
                    context.commit(
                      "setTotalSections",
                      response.data.totalSections
                    );
                    context.commit("setSections", response.data.sections);
                  });
              } else {
                context.commit("setTotalSections", response.data.totalSections);
                context.commit("setSections", response.data.sections);
              }
            });
        });
      return deleted;
    }
  }
};
